import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import globalSettingsReducer from './slices/globalSettingsSlice';
import documentTypesReducer from './slices/documentTypesSlice';
import documentsReducer from './slices/documentsSlice';
import schemasReducer from './slices/schemasSlice';
import tablesReducer from './slices/tablesSlice';
import columnsReducer from './slices/columnsSlice';
import relationshipsReducer from './slices/relationshipsSlice';
import agentConfigurationsReducer from './slices/agentConfigurationsSlice';
import agentToolsReducer from './slices/agentToolsSlice';
import agentPromptsReducer from './slices/agentPromptsSlice';
import chatbotReducer from './slices/chatbotSlice';
import nodesReducer from './slices/nodesSlice';
import graphsReducer from './slices/graphsSlice';
import queryHistoryReducer from './slices/queryHistorySlice';
import clarificationSchemasReducer from './slices/clarificationSchemasSlice';
import clarificationFieldsReducer from './slices/clarificationFieldsSlice';
import optionQueriesReducer from './slices/optionQueriesSlice';
import decisionTreesReducer from './slices/decisionTreesSlice';
import decisionNodesReducer from './slices/decisionNodesSlice';
import guidedChatbotReducer from './slices/guidedChatbotSlice';
import reactChatbotReducer from './slices/reactChatbotSlice';
import chatbotSectionsReducer from './slices/chatbotSectionsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    globalSettings: globalSettingsReducer,
    documentTypes: documentTypesReducer,
    documents: documentsReducer,
    schemas: schemasReducer,
    tables: tablesReducer,
    columns: columnsReducer,
    relationships: relationshipsReducer,
    agentConfigurations: agentConfigurationsReducer,
    agentTools: agentToolsReducer,
    agentPrompts: agentPromptsReducer,
    chatbot: chatbotReducer,
    nodes: nodesReducer,
    graphs: graphsReducer,
    queryHistory: queryHistoryReducer,
    clarificationSchemas: clarificationSchemasReducer,
    clarificationFields: clarificationFieldsReducer,
    optionQueries: optionQueriesReducer,
    decisionTrees: decisionTreesReducer,
    decisionNodes: decisionNodesReducer,
    guidedChatbot: guidedChatbotReducer,
    reactChatbot: reactChatbotReducer,
    chatbotSections: chatbotSectionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
